import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { Helmet } from "react-helmet";
import logoPage from "../static/media/logo.webp";

const blue = "#0A3D91";

const TermsConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      sx={{
        py: { xs: 3, md: 6 },
        px: 2,
        maxWidth: "80%",
        mx: "auto",
      }}
    >
      <Helmet>
        <title>Términos y Condiciones | D&R Soluciones Informáticas</title>
        <meta
          name="description"
          content="Lea los Términos y Condiciones de D&R Soluciones Informáticas. Conozca nuestras políticas de servicio, responsabilidades, obligaciones del cliente y condiciones de retiro para equipos de cómputo y sistemas de seguridad."
        />
      </Helmet>

      <Box sx={{ textAlign: "center", mb: 4 }}>
        <img
          src={logoPage}
          alt="D&R Soluciones Informáticas"
          style={{ maxWidth: "120px", height: "auto" }}
        />
      </Box>

      <Typography
        component="h1"
        sx={{
          textAlign: "center",
          fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.3rem" },
          fontWeight: "bold",
          mb: 4,
          color: blue,
        }}
      >
        Términos y Condiciones
      </Typography>

      <Box sx={{ lineHeight: 1.7, color: "#444" }}>
        <Typography
          component="h2"
          sx={{
            fontSize: { xs: "1.1rem", sm: "1.2rem", md: "1.4rem" },
            fontWeight: "bold",
            mb: 2,
            color: "#333",
          }}
        >
          Políticas de Servicio de D&R Soluciones Informáticas
        </Typography>

        <Typography
          component="h3"
          sx={{
            fontSize: { xs: "1rem", sm: "1.025rem", md: "1.15rem" },
            fontWeight: "bold",
            mb: 1,
          }}
        >
          D&R Soluciones Informáticas se compromete en:
        </Typography>
        <Box
          component="ul"
          sx={{
            pl: 3,
            mb: 3,
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            lineHeight: 1.8,
          }}
        >
          <li>Registrar los datos del cliente, del equipo o del sistema instalado, así como el servicio solicitado.</li>
          <li>Emitir diagnósticos o reportes técnicos dentro de las 48 horas hábiles posteriores al ingreso o instalación.</li>
          <li>Cotizar piezas, materiales o repuestos requeridos para la reparación o instalación del sistema.</li>
          <li>Tramitar garantías de partes y componentes instalados dentro del plazo establecido por el fabricante o distribuidor.</li>
          <li>Realizar instalaciones eléctricas, electrónicas y de software cumpliendo normas técnicas y de seguridad.</li>
          <li>Configurar sistemas de cámaras de seguridad, automatización, control de acceso y domótica según las especificaciones del cliente.</li>
          <li>Verificar el correcto funcionamiento de los equipos y sistemas en presencia del cliente al momento de la entrega o cierre del servicio.</li>
        </Box>

        <Typography
          component="h3"
          sx={{
            fontSize: { xs: "1rem", sm: "1.025rem", md: "1.15rem" },
            fontWeight: "bold",
            mb: 1,
          }}
        >
          D&R Soluciones Informáticas NO se responsabiliza en:
        </Typography>
        <Box
          component="ul"
          sx={{
            pl: 3,
            mb: 3,
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            lineHeight: 1.8,
          }}
        >
          <li>Demoras ocasionadas por proveedores, fabricantes o empresas de transporte externo.</li>
          <li>Daños eléctricos, descargas, fluctuaciones de voltaje o manipulación indebida del sistema después de la instalación.</li>
          <li>Configuraciones modificadas por el cliente o por terceros sin autorización posterior a la entrega del servicio.</li>
          <li>Software, grabaciones o información almacenada en dispositivos DVR, NVR o cámaras que no estén respaldados previamente.</li>
          <li>Fallos por falta de mantenimiento preventivo o limpieza en los equipos o sistemas instalados.</li>
          <li>Partes o componentes retirados por el cliente durante el proceso de servicio.</li>
        </Box>

        <Typography
          component="h3"
          sx={{
            fontSize: { xs: "1rem", sm: "1.025rem", md: "1.15rem" },
            fontWeight: "bold",
            mb: 1,
          }}
        >
          El cliente tiene la obligación de:
        </Typography>
        <Box
          component="ul"
          sx={{
            pl: 3,
            mb: 3,
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            lineHeight: 1.8,
          }}
        >
          <li>Leer y conocer las condiciones de servicio de D&R Soluciones Informáticas.</li>
          <li>Reportar correctamente el tipo de daño, requerimiento o falla del sistema.</li>
          <li>Proporcionar acceso y condiciones seguras para la instalación o mantenimiento de cámaras y automatizaciones.</li>
          <li>Resguardar contraseñas, grabaciones y datos generados por los sistemas instalados.</li>
          <li>Cancelar los valores cotizados y acordados antes del retiro o entrega final del servicio.</li>
          <li>Respaldar la información y/o software instalado en los equipos de cómputo.</li>
        </Box>

        <Typography
          component="h3"
          sx={{
            fontSize: { xs: "1rem", sm: "1.025rem", md: "1.15rem" },
            fontWeight: "bold",
            mb: 1,
          }}
        >
          Condiciones de Retiro y Entrega
        </Typography>
        <Box
          component="ul"
          sx={{
            pl: 3,
            mb: 3,
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            lineHeight: 1.8,
          }}
        >
          <li>Presentar el comprobante de ingreso o documento de servicio al momento de retirar el equipo.</li>
          <li>No adeudar valores pendientes a D&R Soluciones Informáticas.</li>
          <li>Los equipos no retirados después de 60 días de notificación generarán un cargo de bodegaje de $5 mensuales y podrán ser dados de baja o rematados luego de 90 días.</li>
          <li>Los sistemas instalados serán entregados únicamente tras la validación del funcionamiento y firma del acta de conformidad por parte del cliente.</li>
        </Box>
      </Box>
    </Box>
  );
};

export default TermsConditions;
